import React from 'react'

import { Dropdown } from '@sketch/components'
import * as Styles from './PrototypeMenu.styles'
import {
  useArtboardDetailPathname,
  usePrototypeViewContext,
} from 'modules/prototype/PrototypeViewOld/hooks'
import { useNavigation, useUndoRedo } from '@sketch-hq/sketch-prototype-player'

type PrototypeMenuProps = {
  /**
   * Both PrototypeMenu and its child MenuActions can be remounted. Therefore
   * we need to "prop drill" the initialArtboardId value, rather than using
   * the useInitialArtboardId hook (which is not tolerant of being remounted,
   * since that causes it to reset its value). We could "uplift" the
   * initialArtboardId value, perhaps into a context global to the
   * PrototypeView but for now this is small change and solves the issue.
   */
  initialArtboardId: string
}

export function PrototypeMenu(props: PrototypeMenuProps) {
  return (
    <Dropdown
      toggle={
        <Styles.DotsButton aria-label="Prototype menu">
          <Styles.DotsIcon></Styles.DotsIcon>
        </Styles.DotsButton>
      }
      placement="bottom-end"
    >
      <MenuActions initialArtboardId={props.initialArtboardId} />
    </Dropdown>
  )
}

type MenuActionsProps = {
  initialArtboardId: string
}

function MenuActions({ initialArtboardId }: MenuActionsProps) {
  const { restartPrototypeFrom } = useNavigation()
  const { undo, redo, canUndo, canRedo } = useUndoRedo()
  const { enterFullscreen } = usePrototypeViewContext()
  const artboardDetailPathname = useArtboardDetailPathname()

  return (
    <>
      <Dropdown.Header>Prototype</Dropdown.Header>
      <Dropdown.Item onClick={enterFullscreen}>Full Screen</Dropdown.Item>
      <Dropdown.Item.NavLink to={artboardDetailPathname} isActive={() => false}>
        View Artboard
      </Dropdown.Item.NavLink>
      <Dropdown.Divider />
      <Dropdown.Item
        disabled={!canUndo}
        onClick={() => restartPrototypeFrom(initialArtboardId)}
      >
        Restart
      </Dropdown.Item>
      <Dropdown.Item disabled={!canUndo} onClick={undo}>
        Undo
      </Dropdown.Item>
      <Dropdown.Item disabled={!canRedo} onClick={redo}>
        Redo
      </Dropdown.Item>
    </>
  )
}
